import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/helpers";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Wrench, Search } from "lucide-react";

export default function Tools() {
  const [emps, setEmps] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/employees").then((r) => setEmps(r.data)).catch(() => setEmps([]));
  }, []);

  if (!emps) return <Skeleton className="h-64" />;

  const rows = emps.flatMap((e) => (e.tools || []).map((t) => ({ ...t, emp: e.name })));
  const filtered = rows.filter(
    (r) => r.name.toLowerCase().includes(q.toLowerCase()) || r.emp.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">Herramientas Prestadas</h1>
          <p className="text-muted-foreground text-sm mt-1">{rows.length} herramientas asignadas a empleados.</p>
        </div>
        <div className="relative w-full sm:w-72">
          <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input className="pl-9" placeholder="Buscar herramienta o empleado" value={q}
            onChange={(e) => setQ(e.target.value)} data-testid="tools-search" />
        </div>
      </div>

      <Card className="overflow-hidden">
        <Table data-testid="tools-table">
          <TableHeader>
            <TableRow>
              <TableHead>Herramienta</TableHead>
              <TableHead>Nº Serie</TableHead>
              <TableHead>Empleado</TableHead>
              <TableHead>Entrega</TableHead>
              <TableHead>Devolución prevista</TableHead>
              <TableHead>Valor</TableHead>
              <TableHead>Estado</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.length === 0 && (
              <TableRow><TableCell colSpan={7} className="text-center py-10 text-muted-foreground">
                <Wrench className="h-6 w-6 mx-auto mb-2 opacity-40" /> Sin herramientas registradas.
              </TableCell></TableRow>
            )}
            {filtered.map((t) => (
              <TableRow key={t.id}>
                <TableCell className="font-medium">{t.name}</TableCell>
                <TableCell className="font-mono text-xs">{t.serial || "—"}</TableCell>
                <TableCell>{t.emp}</TableCell>
                <TableCell className="font-mono text-xs">{fmtDate(t.delivery_date)}</TableCell>
                <TableCell className="font-mono text-xs">{fmtDate(t.return_date)}</TableCell>
                <TableCell className="font-mono">{t.value || "—"}</TableCell>
                <TableCell><Badge className="bg-sky-100 text-sky-800 border border-sky-200">{t.status}</Badge></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
